import React, { createContext, useState, useEffect } from 'react';
import api from '../api';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [anggota, setAnggota] = useState([]);
  const [setoran, setSetoran] = useState([]);
  const [kelasMeta, setKelasMeta] = useState({
    kelas: '',
    kode_kelas: '',
    pembina: '',
    bendahara: '',
    penyetor: '',
    isComplete: false,
  });
  const [loading, setLoading] = useState(true);

  // Fetch all anggota from backend
  const fetchAnggota = async () => {
    try {
      const res = await api.get('/members');
      setAnggota(res.data);
    } catch (err) {
      console.error('Gagal mengambil anggota:', err);
    }
  };

  // Fetch all setoran from backend
  const fetchSetoran = async () => {
    try {
      const res = await api.get('/contributions');
      setSetoran(res.data);
    } catch (err) {
      console.error('Gagal mengambil setoran:', err);
    }
  };

  const fetchKelasMeta = async () => {
    try {
      const res = await api.get('/members/metadata');
      setKelasMeta(res.data);
    } catch (err) {
      console.error('Gagal mengambil metadata kelas:', err);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      await fetchKelasMeta();
      await fetchAnggota();
      await fetchSetoran();
      setLoading(false);
    };
    loadData();
  }, []);

  // Tambah anggota
  const tambahAnggota = async (anggotaBaru) => {
    try {
      const res = await api.post('/members', anggotaBaru);
      setAnggota([...anggota, res.data]);
      await fetchKelasMeta();
      return res.data;
    } catch (err) {
      console.error('Gagal tambah anggota:', err);
      throw err;
    }
  };

  // Edit anggota
  const editAnggota = async (id, updated) => {
    try {
      const res = await api.put(`/members/${id}`, updated);
      setAnggota(anggota.map(a => a.id === id ? res.data : a));
    } catch (err) {
      console.error('Gagal edit anggota:', err);
      throw err;
    }
  };

  // Hapus anggota
  const hapusAnggota = async (id) => {
    try {
      await api.delete(`/members/${id}`);
      setAnggota(anggota.filter(a => a.id !== id));
      // Hapus juga setoran yang terkait (backend sudah handle cascade, tapi kita filter ulang)
      setSetoran(setoran.filter(s => s.anggota_id !== id));
    } catch (err) {
      console.error('Gagal hapus anggota:', err);
      throw err;
    }
  };

  // Tambah setoran
  const tambahSetoran = async (setoranBaru) => {
    try {
      const res = await api.post('/contributions', setoranBaru);
      setSetoran([...setoran, res.data]);
      return res.data;
    } catch (err) {
      console.error('Gagal tambah setoran:', err);
      throw err;
    }
  };

  // Update setoran (jika diperlukan)
  const updateSetoran = async (id, updated) => {
    try {
      const res = await api.put(`/contributions/${id}`, updated);
      setSetoran(setoran.map(s => s.id === id ? res.data : s));
    } catch (err) {
      console.error('Gagal update setoran:', err);
      throw err;
    }
  };

  // Hapus setoran
  const hapusSetoran = async (id) => {
    try {
      await api.delete(`/contributions/${id}`);
      setSetoran(setoran.filter(s => s.id !== id));
    } catch (err) {
      console.error('Gagal hapus setoran:', err);
      throw err;
    }
  };

  return (
    <AppContext.Provider value={{
      anggota,
      setoran,
      kelasMeta,
      loading,
      tambahAnggota,
      editAnggota,
      hapusAnggota,
      tambahSetoran,
      updateSetoran,
      hapusSetoran,
      fetchAnggota,
      fetchSetoran,
      fetchKelasMeta,
    }}>
      {children}
    </AppContext.Provider>
  );
};